export default {
    en: {
        attributes: {
            prefix: 'Prefix',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email Address',
            password: 'Password',
            passwordConfirmation: 'Password Confirmation',
            password_confirmation: 'Password Confirmation',
            telephone: 'Telephone',
            mobile_telephone: 'Mobile Telephone',
            'offer-first-name': 'First Name',
            'offer-last-name': 'Last Name',
            'offer-email': 'Email',
            'offer-telephone': 'Telephone',
            'offer-buyer': 'Buyer Position',
            'offer-deposit': 'Offer Deposit',
            'offer-amount': 'Offer Amount',
            'thread-subject': 'Subject',
            'thread-message': 'Message',
            'field-company-name': 'Company Name',
            'field-company-address': 'Company Address',
            'field-contact-name': 'Contact Name',
            'field-contact-phone': 'Contact Phone',
            'field-contact-email': 'Contact Email'
        },
        custom: {
            password: {
                regex: 'The password must be at least 8 characters long, have at least 1 uppercase and lowercase letter, and at least 1 number'
            },
            passwordConfirmation: {
                confirmed: 'The password fields must match'
            }
        }
    }
};
